const IN_PROGRESS = {id: 1, title: 'Taken forward'}
const DELAYED = {id: 2, title: 'Declined'}
const WITHOUT_STATUS = {id: 0, title: ''}

const requestsStatuses = [DELAYED, IN_PROGRESS]

export default requestsStatuses
export {IN_PROGRESS, DELAYED, WITHOUT_STATUS}



// WEBPACK FOOTER //
// ./src/constants/requestStatuses.js